'use client'

import { Dialog } from '@headlessui/react'
import { ArrowDownIcon, ArrowUpIcon } from '@heroicons/react/24/outline'
import Image from 'next/image'
import { useRef, useState } from 'react'

import type { CarouselHandlers } from '@src/components/ProductConfigurator/modules/ProductCarousel/ProductCarousel'
import { ProductCarousel } from '@src/components/ProductConfigurator/modules/ProductCarousel/ProductCarousel'
import { ProductGalleryModalContent } from '@src/components/ProductConfigurator/modules/ProductGalleryV2/ProductGalleryModalContent'

export const MobileCarousel = ({
  images,
  setIsModalOpen,
  isModalOpen,
}: {
  images: {
    url: string
    alt: string
  }[]
  setIsModalOpen: (value: boolean) => void
  isModalOpen: boolean
}) => {
  const sliderRef = useRef<CarouselHandlers>(null)
  const [currentSlide, setCurrentSlide] = useState(0)

  return (
    <>
      <ProductCarousel
        slidesPerView={1}
        handlersRef={sliderRef}
        onSlideChanged={setCurrentSlide}
        carouselClassName="gap-4"
        dots={{ color: '#ccc', activeColor: '#208468' }}
        slides={images.map((image, index) => (
          <button
            className="group relative flex w-full cursor-pointer justify-center"
            key={`${image.url}-${index}`}
            onClick={() => {
              setIsModalOpen(true)
            }}
          >
            <Image
              src={image.url}
              alt={image.alt}
              width={332}
              height={332}
              className="pointer-events-none w-full max-w-full rounded-3xl object-contain"
            />
            <div className="absolute right-4 top-4 flex size-10 rotate-45 flex-col items-center justify-center gap-0.5 rounded-full bg-white opacity-0 shadow-md transition-opacity *:stroke-[2px] lg:group-hover:opacity-100">
              <ArrowUpIcon className="size-3" />
              <ArrowDownIcon className="size-3" />
            </div>
          </button>
        ))}
      />
      <Dialog
        transition
        open={isModalOpen}
        className="relative z-50 transition duration-200 ease-out data-[closed]:opacity-0 data-[leave]:opacity-0"
        onClose={() => {
          setIsModalOpen(false)
        }}
      >
        <div className="fixed inset-0 flex h-[100vdh] w-screen items-center justify-center bg-bodi-white">
          <ProductGalleryModalContent
            images={images}
            currentSlide={currentSlide}
            nextSlide={() => sliderRef.current?.moveToIndex(currentSlide + 1)}
            previousSlide={() => sliderRef.current?.moveToIndex(currentSlide - 1)}
            setCurrentSlide={(index) => sliderRef.current?.moveToIndex(index)}
          />
        </div>
      </Dialog>
    </>
  )
}
